export const eur = (v) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v ?? 0);
export const num = (v) => new Intl.NumberFormat('it-IT').format(v ?? 0);
export const fmtDate = (v) => {
  if (!v) return '';
  const d = typeof v === 'string' ? new Date(v) : v;
  return d.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};

export const STATUS_LABELS = {
  pending: 'Nuovo',
  accepted: 'Accettato',
  preparing: 'In preparazione',
  ready: 'Pronto',
  in_delivery: 'In consegna',
  delivered: 'Consegnato',
  rejected: 'Rifiutato',
  cancelled: 'Annullato',
};

export const STATUS_COLORS = {
  pending:      'bg-[#FFF4E1] text-[#8A5A00] border-[#F4D89A]',
  accepted:     'bg-[#EAF6F1] text-[#1F6F5B] border-[#B5DECC]',
  preparing:    'bg-[#FFF4E1] text-[#8A5A00] border-[#F4D89A]',
  ready:        'bg-[#E8F1FF] text-[#1E4E8C] border-[#B8D3F4]',
  in_delivery:  'bg-[#FEE7DF] text-[#B24219] border-[#F7B79E]',
  delivered:    'bg-[#EAF6F1] text-[#1F6F5B] border-[#B5DECC]',
  rejected:     'bg-[#FDECEC] text-[#9B1C1C] border-[#F5B7B7]',
  cancelled:    'bg-[#F1F1F1] text-[#555] border-[#DDD]',
};

export const PAYMENT_LABELS = { cash: 'Contanti alla consegna', card: 'Carta alla consegna' };
